module.exports = __webpack_public_path__ + "img/nearby-food30.7477d656.svg";